export interface AvatarPickerTabElement {
  getUrl: () => Promise<string | null>;
}

export type SelectedEmojiType = {
  id: string;
  native: string;
  unified: string;
};

// Original Dasis brand avatars (pink/violet gradient + white motif), served from
// our own /static/dasisavatar/. Kept under the DROID_/SPIRIT_ export names so the
// existing picker consumers don't change; the two sets back the "Symbols" and
// "Graph" avatar-picker tabs respectively.
export const DASIS_AVATARS_BASE_PATH = "/static/dasisavatar/";

// "Symbols" set — starburst / sparkle / orbit / pulse, 5 gradients each.
export const DROID_AVATARS_BASE_PATH = DASIS_AVATARS_BASE_PATH;
export const DROID_AVATAR_FILES = [
  "sym-01.svg",
  "sym-02.svg",
  "sym-03.svg",
  "sym-04.svg",
  "sym-05.svg",
  "sym-06.svg",
  "sym-07.svg",
  "sym-08.svg",
  "sym-09.svg",
  "sym-10.svg",
  "sym-11.svg",
  "sym-12.svg",
  "sym-13.svg",
  "sym-14.svg",
  "sym-15.svg",
  "sym-16.svg",
  "sym-17.svg",
  "sym-18.svg",
  "sym-19.svg",
  "sym-20.svg",
];

// "Graph" set — 3-node / 5-node graph / arcs / waves, 5 gradients each.
export const SPIRIT_AVATARS_BASE_PATH = DASIS_AVATARS_BASE_PATH;
export const SPIRIT_AVATAR_FILES = [
  "graph-01.svg",
  "graph-02.svg",
  "graph-03.svg",
  "graph-04.svg",
  "graph-05.svg",
  "graph-06.svg",
  "graph-07.svg",
  "graph-08.svg",
  "graph-09.svg",
  "graph-10.svg",
  "graph-11.svg",
  "graph-12.svg",
  "graph-13.svg",
  "graph-14.svg",
  "graph-15.svg",
  "graph-16.svg",
  "graph-17.svg",
  "graph-18.svg",
  "graph-19.svg",
  "graph-20.svg",
];

export const EMOJI_AVATARS_BASE_PATH = "/static/";

// Avatar URLs are relative to the app's own origin (served from /static/), so
// they resolve on whatever domain the app runs on — no hardcoded host.
const buildAvatarUrl = (basePath: string, fileName: string) =>
  `${basePath}${fileName}`;

export const DROID_AVATAR_URLS = DROID_AVATAR_FILES.map((f) =>
  buildAvatarUrl(DROID_AVATARS_BASE_PATH, f)
);
export const SPIRIT_AVATAR_URLS = SPIRIT_AVATAR_FILES.map((f) =>
  buildAvatarUrl(SPIRIT_AVATARS_BASE_PATH, f)
);

export const EMOJI_AVATAR_BASE_URL = buildAvatarUrl(
  EMOJI_AVATARS_BASE_PATH,
  ""
);
